/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_WelcomeInputs */

const en_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Recobra. Select a section from the sidebar to get started.`)
};

const pt_br2_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo ao Recobra. Selecione uma seção na barra lateral para começar.`)
};

/**
* | output |
* | --- |
* | "Welcome to Recobra. Select a section from the sidebar to get started." |
*
* @param {Dashboard_WelcomeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_welcome = /** @type {((inputs?: Dashboard_WelcomeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_WelcomeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_welcome(inputs)
	return pt_br2_dashboard_welcome(inputs)
});